window.__SWATCH_COLORS__ = {
	black: "#000000",
	navy: "#282099",
	white: "#FFFFFF",
	orange: "#e25100",
	blue: "#0000FF",
	"544-black-gum": "#212121",
	"006-black-neon-pink": "#000000",
	"011-jet-black-mlt": "#000000",
	"020-gunmetal": "#838b8b",
	"105-clear-with-blue-pads": "#ADD8E6",
	"012-black-lux-cyan": "#000808",
	"007-black-color-floral": "#000700",
	"101-clear-with-clear-pads": "#FFFFFF",
	"003-black-sand-multi": "#262322",
	"041-smoke": "#888488",
	"007-black-white-floral": "#000000",
	"003-ebony": "#4A4A4A",
	"006-cast-black": "#1D2123",
	"019-black-sunset-pink": "#000000",
	"029-gray-black": "#262626",
	"019-grey": "#A7A9AC",
	"030-gunmetal": "#828B8E",
	"002-black-skyblue": "#00002B",
	"041-smoke-red": "#593737",
	"032-metallic-steel": "#B0C4DE",
	"027-black-blackberry": "#301934",
	"010-charcoal": "#36454F",
	"045-smoke-red-mirror": "#504A4B",
	"001-black": "#000000",
	grey: "#808080",
	"092-lt-grey": "#D3D3D3",
	"004-multi": "#000068",
	"101-clear-black": "#000000",
	"002-red-black": "#000000",
	"040-silver": "#C0C0C0",
	"055-smoke-red": "#544B47",
	"007-jet-black": "#000000",
	"139-slate": "#708090",
	"004-black-mlt": "#000000",
	"016-black-denim": "#222F3A",
	"011-black-blues": "#000011",
	"036-graphite-silver": "#B3B6B7",
	"001-black-white": "#000000",
	"011-black-blue": "#000011",
	"101-white": "#F8F8FF",
	"041-metallized-smoke": "#4A5153",
	"030-black-pink": "#000000",
	"033-stone-gray-black": "#4A4A4A",
	"004-black-out-multi": "#000000",
	"095-mirrored-silver": "#C0C0C0",
	"041-smoke-mirror-silver-black": "#171717",
	"011-blue-black": "#000011",
	"134-white-lt-blue": "#F0F8FF",
	"115-white-red": "#FFFFFF",
	"006-blk-pink": "#000000",
	"043-silver-black-clear": "#C0C0C0",
	"094-black-fl-yellow": "#000000",
	"003-black-out": "#000000",
	"119-white-mlt": "#F4F3EF",
	"143-titanium-blue": "#778492",
	"030-gun-metal": "#81878B",
	"151-clear-silver": "#C0C0C0",
	"007-jet-black-pattern": "#000000",
	"043-silver-black": "#A9A9A9",
	"092-smoke": "#778179",
	"014-black-green": "#004000",
	"light-blue": "#ADD8E6",
	"007-polka-dots": "#2E3A87",
	"050-light-grey": "#D3D3D3",
	"125-black-jade": "#2B342B",
	"007-jet-black-multi": "#000000",
	"021-dark-gray": "#A9A9A9",
	"007-clear-black": "#000000",
	"001-black-charcoal": "#0A0A0A",
	grass: "#7CFC00",
	"008-black-gold": "#fff225",
	"020-grey": "#333333",
	red: "#FF0000",
	"095-metallic-silver": "#A8A9AD",
	"005-black-white": "#000000",
	"004-black-multi": "#000000",
	"040-silver-black": "#A9A9A9",
	"104-supernova": "#FFCC00",
	"015-black-glitter": "#000000",
	"119-white-blue": "#003fbf",
	"093-black-blue-smoke": "#222F3A",
	"005-black-wht": "#000000",
	tiffany: "#0ABAB5",
	"152-clear-black-pink": "#000000",
	"101-white-out": "#F4F4F4",
	"055-smoke-red-black": "#222222",
	"093-black-blue": "#1e7cff",
	"100-white": "#FFFFFF",
	"101-clear-silver": "#C0C0C0",
	"054-grey-pink": "#BDB5B3",
	"043-silver-smoke-black": "#A9A9A9",
	"100-white-black": "#808080",
	"128-black-lt-blue": "#000080",
	"003-onyx": "#353839",
	"002-black-red": "#FC2222",
	"130-shell": "#F2F1EB",
	"135-white-grey": "#F2F2F2",
	"029-grey-black": "#919191",
	violet: "#800080",
	"095-metallized-silver": "#A7A9AC",
	"101-fresh-whit": "#F5F6F0",
	"011-clear-black-blue": "#00008B",
	"013-black-dream-fuschia": "#000000",
	pink: "#FFC0CB",
	"007-black": "#000000",
	"140-titanium-metallic": "#848789",
	"036-graphite": "#25262b",
	green: "#00FF00",
	"110-ivory": "#FFFFF0",
	"116-white-green": "#F0FFF0",
	"007-black-white": "#FFFFFF",
	"042-smoke-pink": "#F0E6FA",
	"101-clear-blue": "#ADD8E6",
	"112-bone": "#E3DAC9",
	"105-clear-purple-blue": "#A090C0",
	"046-silver-black-blue": "#A9A9A9",
	aqua: "#00FFFF",
	"045-charcoal-red": "#36454F",
	"004-black-multi-1": "#000000",
	"041-smoke-black": "#040404",
	"046-silver-blue-black": "#A9A9A9",
	"033-grey-black": "#033333",
	"152-clear-purple-pink": "#F2D7D9",
	"004-blk-multi": "#000000",
	"111-blush-balm": "#E3BDBA",
	"031-heather": "#A4B07E",
	"051-grey-red": "#A9A9A9",
	"148-grey-yellow": "#A49F59",
	"103-clear-black": "#000000",
	"100-white-metallic": "#F2F2F2",
	"107-clear-pink-yellow": "#F9D3EE",
	"04-navy": "#000080",
	"006-castaway-black": "#161616",
	"062-black-orange-1": "#f74200",
	"092-lt-grey-camo": "#A3B18A",
	"002-black-sand": "#070707",
	"088-black-gray": "#222222",
	"076-black-coral": "#24140E",
	"074-smoke-black-yellow": "#232323",
	"092-lt-smoke": "#E0E0DA",
	"102-bck-in-wht": "#F0F8FF",
	"006-black-royal": "#000066",
	"028-black-blue-coral": "#001A33",
	"107-clear-yellow-orange": "#F0AB00",
	"111-blonde": "#F0E68C",
	"086-black-lt-blue": "#000000",
	"075-silver-black": "#A9A9A9",
	"068-black-purple": "#291A2B",
	"064-black-silver": "#212121",
	"050-graphite": "#252525",
	"136-white-steel": "#B2BEB5",
	"060-black-white": "#000000",
	"075-smoke-silver-mirror": "#848884",
	"135-white-gray": "#D3D3D3",
	"074-smoke-black": "#232323",
	"132-white-gold-1": "#F5F5DC",
	"086-black-light-blue": "#000864",
	"118-white-jade": "#F0FFF0",
	"084-steel-grey": "#4682B4",
	"072-smoke-white": "#F5F5F5",
	"112-white-navy": "#F0F8FF",
	"094-ash": "#AFAFAF",
	"140-titanium": "#B8B8B8",
	"080-eclipse": "#383838",
	"233-plasma": "#7A65F3",
	"077-navy-pink": "#000080",
	"076-gr-heather": "#A9A59F",
	"223-gold-metal-rainbow-black": "#8267BC",
	"121-black-pink": "#000000",
	"116-white-sand": "#D3CDC6",
	"142-titanium-pink": "#D1B0C4",
	"254-light-heather": "#E0E0E0",
	"108-pearl": "#F0EEE3",
	"152-clear-pink-orange": "#F2A76B",
	"234-inferno": "#B14E23",
	"250-red-navy": "#FA0080",
	"165-solar-metallic": "#A7914B",
	"232-pink-turquoise": "#D06FA6",
	"158-clear-red-orange": "#FFA500",
	"062-black-orange": "#000000",
	"208-khaki-brown": "#C3B091",
	"272-khaki": "#CDC08C",
	"113-blush": "#DEB887",
	"222-bronze": "#CD7F32",
	"198-steel-green": "#23784B",
	"069-black-yellow": "#000000",
	"073-smoke-yellow": "#F4F3EE",
	"241-dune": "#E1D7C0",
	"063-black-burgundy": "#060303",
	"112-navy-white": "#000080",
	"210-avocado": "#9CB071",
	"21-pink": "#FF69B4",
	"119-white-multi": "#F8F8F4",
	"255-charcoal-heather": "#464646",
	"164-lunar-metallic": "#C0C4C8",
	"161-metallic-ocean": "#0A2331",
	"173-pink-yellow-orange": "#F28500",
	"128-black-lt-blue-1": "#000080",
	"222-silver-metal-silver-black": "#222222",
	"260-iguana": "#73A942",
	"206-tropical-brown-multi": "#996633",
	"211-brown-multi": "#A0785A",
	"188-black-blue-green": "#002E40",
	"290-camo": "#718261",
	"200-brown": "#8B4513",
	"064-silver-black": "#A9A9A9",
	"075-metallized-smoke": "#4A5153",
	"165-solar-silver-metallic": "#9FA3A8",
	"172-pink-yellow-blue": "#F091A9",
	"175-yellow-blue-red": "#AE9839",
	"301-fresh-mint": "#D2F2E0",
	"186-white-multi": "#FFFFFF",
	"184-pink-purple": "#D81E5B",
	"183-blue-pink-yellow": "#728FCE",
	"204-tropical-brown": "#634A34",
	"288-mahogony": "#C04000",
	"168-black-pink-green": "#000000",
	"240-walnut": "#77695C",
	"152-clear-pink": "#F2B7BD",
	"273-green-grey-navy": "#395B64",
	"257-sumer-sand": "#F0E68C",
	"176-black-blue-red": "#020B10",
	"207-brown-khaki": "#C39B6B",
	"133-white-purple": "#F0E6FF",
	"158-clear-red-black": "#800000",
	"060-black-multi": "#000000",
	"261-camel": "#C19A6B",
	"059-black-aqua": "#000000",
	"293-black-neon": "#232323",
	"196-white-grey-black": "#F0F0F0",
	"130-shell-a": "#F2F1EB",
	"201-brown-orange": "#A0522D",
	"292-camo-orange": "#6F4E37",
	"187-black-nrd-red": "#000000",
	"298-gold-green-blue": "#B8860B",
	"305-evergreen": "#387C6D",
	"156-smoke-green-blue": "#7DB9DE",
	"147-grey-purple": "#8E7CC3",
	"197-x-ray": "#D1D3D2",
	"256-taupe": "#483C32",
	"238-heather-navy": "#123063",
	"249-black-blue-aqua": "#004040",
	"252-sand-dune": "#F0EEE3",
	"060-zebra": "#0A141E",
	"298-gold-green-navy": "#A7A449",
	"177-grey-blue-purple": "#6F7385",
	"236-blue-green-yellow": "#BCE20A",
	"199-steel-blue": "#4682B4",
	"219-taupe": "#483C32",
	"197-black-white": "#212121",
	"218-caramel": "#D2B48C",
	"312-green-yellow": "#ADFF2F",
	"105-clear-blue-black": "#000000",
	"253-black-grey": "#3D3D3D",
	"297-clear-green-black": "#004B00",
	"182-purple-pink-blue": "#A295D6",
	"259-sand": "#E6DDC6",
	"268-yellow-pink": "#F29C9E",
	"237-heather-black": "#434343",
	"252-heather-grey": "#9f9f9e",
	"216-crystal": "#A7D8DE",
	"220-yellow-pink": "#F4C2C2",
	"193-grey-navy": "#334756",
	"305-evergreen-black": "#2E3436",
	"307-green-orange": "#769700",
	"307-green-orange-smoke": "#7DB863",
	"310-fiji-green": "#639B6A",
	"316-green-pink": "#78FF8F",
	"228-mocha": "#967969",
	"202-chocolate": "#D2691E",
	"327-limelight": "#B7E354",
	"166-white-orange": "#FFF3E0",
	"225-coconut-brown": "#966F33",
	"185-purple-multi": "#663399",
	"310-camo": "#737868",
	"312-desert-sage": "#A8BB94",
	"061-black-turquoise": "#061B14",
	"326-apple-green": "#8DB600",
	"333-lux-teal": "#217346",
	"316-palm-green": "#D0E2BB",
	"312-dark-sage": "#598556",
	"295-black-brtgrn": "#000000",
	"331-jade": "#00A36C",
	"340-green-black": "#006400",
	"310-green-blue-multi": "#77B5A8",
	"231-pink-multi": "#e74848",
	"265-sand-multi": "#E2D7C0",
	"160-metallic-fire": "#CD7F32",
	"320-light-green": "#90EE90",
	"322-fluorescent-green-multi": "#7CFC00",
	"329-army-green": "#4B5320",
	"298-gold-green-fl-yellow": "#E6B800",
	"324-fl-green-black": "#3CBB75",
	"343-tile-blue": "#0078A3",
	"155-grey-blue": "#9BABB3",
	"320-green-lime": "#5ec202",
	"333-seafoam": "#ace9de",
	"126-white-pink": "#F2E6E6",
	"340-electric-hunk": "#7DF9FF",
	"338-pink-green": "#C8E6C9",
	"322-green": "#6B8E23",
	"291-neon": "#7CFC00",
	"154-clear-gold-mirror-black": "#E4CE01",
	"150-clear-mirror-ice": "#E0E8EA",
	"310-green": "#60B236",
	"403-regatta": "#4A646C",
	"332-chartreuse": "#7FFF00",
	"376-glamour": "#9E768F",
	"402-harbor-blue": "#26455E",
	"379-navy-pink": "#000080",
	"355-jade": "#00A36C",
	"356-lady-jade": "#A8CBB7",
	"403-blue-sea": "#66A5AD",
	"346-dark-teal": "#008080",
	"332-mint": "#98FF98",
	"373-ocean-blue": "#36a5ff",
	"407-navy-royal": "#003366",
	"401-navy-1": "#000080",
	"404-sky-blue": "#87CEEB",
	"353-coastal-jade": "#6DB39F",
	"365-luxury": "#332927",
	"361-teal-stone": "#6caea7",
	"332-lime": "#BEF700",
	"314-olive": "#6B8E23",
	"404-aquamarine": "#7FFFD4",
	"342-sage": "#BCB88A",
	"322-fluorescent-green": "#7CFC00",
	"349-teal-cove": "#68B0AB",
	"401-navy-white": "#000080",
	"403-crew-blue": "#37607C",
	"355-cobalt": "#1671df",
	"343-topaz-teal": "#007A74",
	"340-green-black-fl-green": "#008000",
	"323-lt-green-navy": "#90EE90",
	"339-dark-fatigue": "#5F6B59",
	"380-blue-ice-metallic": "#8FA9B3",
	"346-ivy": "#3F704F",
	"347-bonsai": "#647C64",
	"344-olive": "#708238",
	"356-pool": "#98D8D8",
	"341-grasshopper": "#7DB954",
	"339-electric-lime": "#CCFF00",
	"261-khaki": "#F0E68C",
	"404-navy-red-1": "#e91c13",
	"404-multi": "#808080",
	"374-navy-royal": "#00308F",
	"402-navy": "#000080",
	"358-evergreen": "#387C44",
	"352-fatigue": "#78714F",
	"406-navy-orange": "#000080",
	"405-blue-hawaiian-mlt": "#73A5C6",
	"405-navy": "#000080",
	"404-tide-pool": "#5FA8D3",
	"402-blu-ribbon": "#43598B",
	"420-blue-mirror-blue-black": "#0A1128",
	"412-new-navy": "#232946",
	"409-sea-blue": "#006994",
	"403-mid-red": "#B33A3A",
	"404-blue-lounge": "#3B4252",
	"416-navy-turqoise": "#008080",
	"354-sea-jade": "#2E8B57",
	"368-ink": "#222E3A",
	"359-summer-jade": "#6AB187",
	"390-blue-pink": "#887DA3",
	"350-riviera": "#438EB9",
	"400-blue": "#2979FF",
	"404-navy-red": "#000080",
	"413-bay-blue": "#597D89",
	"413-navy-coral": "#0A1128",
	"388-navy-lt-green": "#2E3A46",
	"404-navy": "#000080",
	"371-blue-pink": "#B284BE",
	"413-peek-a-blu": "#9DBFDB",
	"405-blue-multi": "#293A8F",
	"330-palm": "#D0E2B2",
	"408-midnight": "#0D1B2A",
	"401-navy": "#000080",
	"412-sea-saw": "#3A4F4F",
	"375-navy-glamour": "#001F3F",
	"410-new-navy": "#0D2147",
	"404-red-navy": "#800000",
	"423-navy-captain": "#1E2743",
	"404-light-blue": "#ADD8E6",
	"411-blue-denim": "#224064",
	"416-navy-mlt": "#000080",
	"420-deep-ocean": "#00416A",
	"421-misty-blue": "#DAE4E7",
	"406-navy": "#000080",
	"420-blue-clear": "#0080FF",
	"415-blueviolet": "#8A2BE2",
	"403-beach-water": "#79B4A9",
	"340-green-black-fl-yellow": "#008000",
	"318-forest": "#00755E",
	"341-popsicle": "#72A3C9",
	"318-kelly-green": "#4CBB17",
	"412-navy-blue-wave": "#1E3A8A",
	"425-royal": "#4169E1",
	"402-blue-sea": "#66A5AD",
	"407-blue-wave": "#84A0C6",
	"420-blue-multi": "#355070",
	"403-navy": "#000080",
	"417-navy-blackberry": "#000080",
	"413-cadet": "#536878",
	"424-coastal-blue": "#48A0C9",
	"424-blue-navy-red": "#1E3A8A",
	"420-blue-clear-silver": "#74ACDF",
	"412-marine": "#336B87",
	"417-water": "#D6F0F3",
	"420-deep-sea": "#005680",
	"408-navy-white": "#000080",
	"345-fern": "#6CB366",
	"434-ink": "#292929",
	"418-twilight-blue": "#51607A",
	"430-bright-blue": "#0095B6",
	"418-twilght-blue": "#72A0C6",
	"431-green": "#6F8E23",
	"424-blue-red": "#2A2ABD",
	"442-dark-turquoise": "#008080",
	"411-navy-capta": "#192354",
	"419-blue-navy": "#2A4178",
	"428-royal": "#4169E1",
	"432-seabreeze": "#DAE8E3",
	"394-bright-green": "#66FF00",
	"425-blue-waterfall": "#77B5CD",
	"439-beach-blue-mlt": "#79B4C6",
	"407-navy": "#000080",
	"390-blue-pink-turq": "#73B9C9",
	"447-sea-blue": "#0077BE",
	"414-marine": "#3D59AB",
	"416-cloud": "#F0F0F4",
	"442-black-lux-cyan": "#000000",
	"402-cobalt": "#0047AB",
	"451-sky-blue": "#87CEEB",
	"419-true-blue": "#478DCB",
	"407-port-royale": "#A8516E",
	"416-navy-blue": "#000080",
	"420-blue-silver": "#72A0C1",
	"422-clear-blue-black": "#0A192F",
	"424-bermuda-checks": "#D0E0C1",
	"424-bermuda-stripe": "#7CBCB0",
	"420-blue-lt-blue": "#90CAF9",
	"422-blue-black": "#1E293B",
	"431-peacock": "#006A4E",
	"435-royal-purp": "#7851A9",
	"419-navy-blue": "#000080",
	"420-blue": "#4863A0",
	"441-macaw-blue": "#26848C",
	"420-blue-black": "#121B2B",
	"436-rpurpmulti": "#6E3CBC",
	"428-mist": "#E4E9E5",
	"429-royal-green": "#4169E1",
	"420-blue-translucent-blue": "#6488EA",
	"457-navy-red": "#000080",
	"425-lt-aruba": "#A0D6B4",
	"416-navy-multi": "#000080",
	"342-teal": "#008080",
	"426-azure": "#F0FFFF",
	"437-beach-blue": "#A0CED9",
	"436-peacock": "#13b1f9",
	"426-sky": "#76D7EA",
	"405-navy-green": "#293347",
	"429-cobalt": "#0047AB",
	"418-navy-multi": "#000080",
	"433-cobalt": "#284B63",
	"456-light-blue-black": "#ADD8E6",
	"416-navy-turquoise": "#2da998",
	"410-navy": "#000080",
	"451-metallized-sky-blue": "#778B9E",
	"424-bermuda": "#6CD2EE",
	"452-lt-blue": "#ADD8E6",
	"427-royal-navy": "#00246B",
	"453-blueberry": "#77A1D3",
	"428-aruba": "#378F92",
	"452-larimar-aqua": "#65D6B3",
	"427-blue-sky": "#77B5FE",
	"428-navy-green-pink": "#2A52BE",
	"446-copa-aqua": "#84D3D1",
	"461-blue-multi": "#3B5998",
	"447-storm-metallic": "#51575E",
	"436-oasis": "#FAEBD7",
	"425-stream": "#607C6C",
	"432-lt-hydro": "#B7D5D7",
	"465-blue-yellow-green-orange": "#6495ED",
	"452-light-blue": "#ADD8E6",
	"440-blue": "#3F51B5",
	"449-tahitiblue": "#38B0DE",
	"449-ocean": "#4C799C",
	"457-navy-ii-red": "#1D2951",
	"421-surf-blue": "#7BB5C1",
	"460-blue-navy-black": "#000080",
	"409-navy-gold": "#000080",
	"459-navy-grey": "#303A60",
	"450-light-blue": "#ADD8E6",
	"440-turquoise": "#40E0D0",
	"460-blue-navy": "#1E284B",
	"447-overboard-aqua": "#72BDA3",
	"441-aqua": "#00FFFF",
	"450-inspire": "#67B7DC",
	"450-pool": "#A3D6C6",
	"447-storm": "#6bafe7",
	"472-navy-royal": "#00308F",
	"431-royal-mlt": "#6B8E23",
	"439-hyacynth": "#6441A5",
	"435-blue-bliss": "#6699CC",
	"463-camo-blue": "#737868",
	"443-caribe-aqua": "#00A79D",
	"492-blue-orange": "#4682B4",
	"461-navy-multi": "#292352",
	"442-dark-turq": "#008080",
	"408-marina": "#006994",
	"430-royal": "#4169E1",
	"422-denim": "#283B5B",
	"479-berry-fizz": "#D34D89",
	"487-blue-green-1": "#2190a2",
	"448-prin-ac-bl": "#2A364F",
	"470-blue-gold-mirror": "#1E3A8A",
	"481-blue-silver-mirror": "#34577A",
	"466-vintage-blue": "#669999",
	"467-grecian-blue": "#68B3C8",
	"448-navy-coral": "#001F3F",
	"438-marine": "#2A4958",
	"461-multi-blue": "#293B94",
	"504-paradise-peri": "#B0B0DA",
	"451-aqua-breeze": "#E0F2F1",
	"487-clear-blue-green": "#7bc4c4",
	"442-lux-cyan": "#A7D9ED",
	"466-blue-green": "#6495ED",
	"450-inspire-h73624b": "#73624B",
	"478-royal-black": "#2E294E",
	"482-ultramarine-blue": "#4166F5",
	"465-blue-yellow": "#6495ED",
	"464-blue-fizz": "#6E9DD0",
	"439-lapis": "#2E5894",
	"450-lt-blue": "#ADD8E6",
	"446-aqua": "#00FFFF",
	"466-caribean-blue": "#00CC99",
	"510-purple-black": "#210029",
	"474-cerulean-multi": "#007BA7",
	"422-hydro": "#71A6D2",
	"420-metal-blue": "#2A4F6E",
	"499-blue-crush": "#6699CC",
	"484-royal-yellow": "#FADA5E",
	"462-blue-white": "#ADD8E6",
	"501-plum": "#8E4585",
	"499-radiant-blue": "#29ABE2",
	"510-purple-multi": "#663399",
	"510-purple": "#724DA1",
	"501-grape-soda": "#7264A2",
	"465-blue-yellow-pink": "#505CB4",
	"503-burgundy": "#800020",
	"497-black-mint-pink": "#000000",
	"493-peacock": "#006A4E",
	"496-blue-mint": "#B0E2FF",
	"511-purple": "#720058",
	"465-blue-yellow-orange": "#096DD9",
	"491-caribbean-aqua": "#00D9A5",
	"481-metallized-blue": "#2E59A2",
	"509-clear-pink-purple": "#E6C2E0",
	"449-martinica": "#385B6D",
	"495-blue-purple": "#646691",
	"513-pale-violt": "#D8B4DE",
	"473-royal": "#4169E1",
	"437-220-volts": "#6B3C00",
	"470-royal-gold": "#C4B352",
	"446-blue-red": "#466596",
	"511-admiral": "#2E3A51",
	"556-fl-orange-yellow": "#FF9933",
	"465-blue-translucent-yellow": "#4682B4",
	"445-aqua": "#00FFFF",
	"449-aqua-multi": "#7FFFD4",
	"519-dark-periwinkle": "#666394",
	"525-gypsy": "#A7754D",
	"532-periwinkle-metallic": "#696EB7",
	"482-royal-multi": "#372772",
	"496-blue-grey-navy": "#314B61",
	"473-royal-white": "#002366",
	"580-purple-multi": "#7030A0",
	"531-lilac": "#B6A3D3",
	"533-crystal": "#D1D9E1",
	"508-violet": "#9370DB",
	"510-clear-purple": "#7F00FF",
	"512-admiral": "#033E6B",
	"489-riviera-blue": "#4396D6",
	"446-aqua-marine": "#7FFFD4",
	"511-purple-yellow": "#808000",
	"481-blue-ice-blue": "#B0E2FF",
	"478-bluebell": "#A2A2D0",
	"490-blue-turqoise": "#2EE6D6",
	"526-purple-black": "#221A29",
	"542-purple-turquoise": "#778899",
	"510-royal-pink": "#8E4585",
	"511-admiral-pattern": "#323B47",
	"607-poppy": "#E34234",
	"513-admiral-ml": "#1A3347",
	"569-turqoise-blue": "#70DBD2",
	"514-purple-lavender": "#D8B4DE",
	"547-purple-pink-multi": "#D0A8D8",
	"487-blue-green": "#2CB7B0",
	"523-navy-purple": "#2E3192",
	"510-metallized-purple": "#7A527B",
	"472-royal-navy": "#00308F",
	"473-cerulean": "#2A52BE",
	"554-cabernet": "#4B3621",
	"513-orchid-purple-multi": "#A64AC9",
	"526-clear-purple-blue": "#8080FF",
	"605-infrared": "#F03D3D",
	"473-ceruliean": "#2A52BE",
	"509-clear-black-purple": "#22223B",
	"531-lavender": "#E6E6FA",
	"503-burgandy": "#800020",
	"510-purple-translucent-purple": "#800080",
	"602-wild-ginger": "#B06547",
	"579-black-red-blue": "#000000",
	"529-velvet": "#75426A",
	"545-gold-purple-blue": "#B19CD9",
	"542-amethyst": "#9966CC",
	"598-maroon-gold": "#800000",
	"545-purple-blue": "#666699",
	"591-crimson": "#DC143C",
	"577-black-blue-orange": "#191919",
	"557-silver-turq-pink": "#C0C0C0",
	"513-purple-blue": "#666699",
	"551-fuchsia": "#C71585",
	"598-maroon-white": "#800000",
	"547-purple-pink": "#D0A0DF",
	"603-campari": "#A25149",
	"604-true-red": "#b32134",
	"609-burgundy-gold": "#800020",
	"611-hot-cherry": "#B7282E",
	"514-blackberry": "#4D3659",
	"511-admiral-h78606": "#364869",
	"481-ocean": "#3D7DA8",
	"502-periwinkle": "#CCCCFF",
	"599-maroon-gold": "#800000",
	"573-aqua-navy": "#167880",
	"614-geranium": "#E15D44",
	"541-bright-purple": "#BE3CBC",
	"540-passion-fruit": "#E95268",
	"576-black-green-yellow": "#008000",
	"584-yellow-grey-blue": "#D1C6A7",
	"578-black-turquoise-purple": "#008080",
	"531-metallized-lavender": "#7B6885",
	"574-purple-pink": "#D04ED6",
	"614-red-pink": "#DA294B",
	"513-sapphire": "#286491",
	"610-coral-reef": "#FF4040",
	"610-metal-red": "#A81C07",
	"630-black-green-blue": "#006300",
	"620-magenta": "#C00098",
	"511-deep-purpl": "#301934",
	"602-chili-red": "#D04125",
	"609-sangria": "#92003A",
	"620-magenta-white": "#FF00FF",
	"613-red-purple": "#D633FF",
	"485-royal-red": "#6A0DAD",
	"575-lt-blue-black": "#A1B3C4",
	"625-pink-sorbet": "#F29EA9",
	"626-iced-cherry": "#B25068",
	"640-fl-red-black": "#FF0000",
	"621-bright-red": "#FF0000",
	"610-red-white": "#FFFFFF",
	"623-candy-apple": "#FF0800",
	"635-cherry-red": "#C21807",
	"577-black-orange-blue": "#000000",
	"583-red-blue-grey": "#925858",
	"601-burgundy-pink": "#A3536B",
	"629-black-pink-red": "#000000",
	"615-red-blue": "#DC143C",
	"610-red-black": "#8B0000",
	"517-rumba": "#987474",
	"671-pink-blue": "#E2D6F9",
	"623-sea-coral": "#FF4040",
	"605-vivid-pink": "#DA1884",
	"612-red-grey": "#A6937C",
	"614-red-pink-1": "#D81E5B",
	"620-red-magenta-mirror": "#C2144D",
	"625-poppy-solid": "#E34234",
	"659-silver-black-pink": "#C0C0C0",
	"492-gold-blue-orange": "#D4A017",
	"636-red-white-navy": "#B22234",
	"555-fl-pink-orange-1": "#FF5F00",
	"663-dream-fuschia-black": "#A7008B",
	"627-red-gold-mirror": "#B4463D",
	"610-bloom": "#D8BFD8",
	"646-red-white-blue": "#B22234",
	"555-fl-pink-orange": "#FF5F00",
	"657-silver-camo": "#A7A8AA",
	"661-metallized-pink": "#D47FA6",
	"659-silver-pink-purple": "#C2B5C9",
	"660-hot-pink": "#FF69B4",
	"657-silver-green": "#C0C0C0",
	"600-red": "#E53935",
	"671-pink-lemonade": "#E4D1D0",
	"649-fig": "#6C3456",
	"611-red-multi": "#9A2A2A",
	"610-red": "#e20f0f",
	"549-lt-quartz": "#E3DED5",
	"679-pink-green": "#D0E2B0",
	"631-grey-green-blue": "#A3B18A",
	"658-silver-white": "#F0F0F0",
	"662-dream-fuschia": "#F2B3D4",
	"667-pink-black-white": "#FF69B4",
	"632-navy-green-pink": "#00308F",
	"670-pink-silver-metallic": "#D8B7C4",
	"667-pink-white": "#FFD1DC",
	"670-pink-aqua-flowers": "#F2D3D9",
	"670-neon-pink": "#FF6EC7",
	"658-silver-fl-yellow-white": "#C0C0C0",
	"625-poppy": "#E35335",
	"659-coral-multi": "#FF7F50",
	"672-power-pink": "#D077AC",
	"690-sunset-pink": "#F8C8DC",
	"639-red-orange": "#F2552C",
	"659-tropical-glow": "#FFDB58",
	"652-passion-lily-multi": "#D394C2",
	"606-black-blue-red": "#000000",
	"666-fuschia": "#FF00FF",
	"690-pink-me-up": "#E7A1A1",
	"653-berry": "#A0528A",
	"652-cerise": "#DE3163",
	"511-deep-amethyst": "#9C6DA5",
	"653-summer-pink": "#F6B2BE",
	"636-red-white-blue": "#223dd4",
	"642-red-navy": "#9E2F2F",
	"652-fuchsia": "#C71585",
	"604-burgundy": "#800020",
	"689-deep-pink": "#FF1493",
	"654-be-pink-ml": "#E5B9BC",
	"670-fluorescent-pink": "#FF69B4",
	"644-cordovan": "#893F45",
	"678-pink-purple-mint": "#D8BFD8",
	"678-pink-purple": "#D87093",
	"693-fl-pink-white": "#FF69B4",
	"601-little-ruby": "#966F7E",
	"650-pink": "#D74894",
	"651-passion-lily": "#D362A4",
	"690-persimmon": "#F07663",
	"669-malibu-pink": "#D1A2A9",
	"629-cherry": "#E5004F",
	"653-violet": "#8600AF",
	"655-sunset-pink": "#F8E8E7",
	"646-merlot": "#4E2A5A",
	"618-hibiscus": "#B7475F",
	"648-metallic-red-silver": "#A87878",
	"691-pink-yellow": "#F7E26B",
	"658-wink-pink": "#F4D5D5",
	"665-petunia": "#962FBF",
	"650-light-pink": "#FFB6C1",
	"680-watermelon": "#FFA7A7",
	"700-amber-purple-mirror": "#9F6834",
	"691-hot-pink-mlt": "#E5007D",
	"664-sugar-rush": "#F0B2D7",
	"696-pink-multi": "#E3A8B8",
	"677-rosewood": "#65000B",
	"670-pink-camo": "#D8BCC0",
	"671-pink-blue-orange": "#F08080",
	"706-black-lime-blue": "#0A1117",
	"642-silver-red-navy": "#C0C0C0",
	"707-black-green-lt-blue": "#006400",
	"671-pink-p": "#E20074",
	"682-hibiscus-pink": "#D44F78",
	"681-baja-pink": "#F0B2A7",
	"685-pink-purple-orange": "#D06B9D",
	"660-rose": "#E37383",
	"682-baja-pink": "#E7DAD2",
	"693-fl-pink-silver": "#F778A1",
	"641-rosewood": "#65000B",
	"685-pink-orange": "#F08080",
	"680-blush": "#D98190",
	"662-fuschia": "#C21E56",
	"681-pink-guava": "#EF98AA",
	"657-sun-beam": "#EFC050",
	"721-yellow-green": "#A6B320",
	"638-red-yellow": "#FFAA00",
	"704-black-seafoam": "#292B27",
	"638-red-fl-yellow-black": "#FF0000",
	"719-silver-fl-yellow-blue": "#C0C0C0",
	"670-pink-multi": "#E6B8AF",
	"719-silver-black-yellow": "#C0C0C0",
	"700-yellow": "#FDD835",
	"704-black-seafom": "#292421",
	"677-rose": "#C72C48",
	"712-limoncello": "#FEE182",
	"695-pink-ombre": "#E9D6CE",
	"701-amber": "#FFBF00",
	"717-silver-red-white": "#C0C0C0",
	"661-ultra-pink": "#FF6EFF",
	"690-sunbeam-mlt": "#FEDB86",
	"653-cerise": "#DA2941",
	"712-gold-red": "#B76E38",
	"703-turqoise-navy": "#008080",
	"670-bright-pink": "#FF007F",
	"718-silver-mint-black": "#C0C0C0",
	"700-amber-blue": "#FFBF00",
	"683-pink-lemonade": "#E0BBE4",
	"744-navy-red-white": "#000080",
	"660-rose-pink": "#FF6699",
	"750-gold": "#FDD20E",
	"700-amber": "#FF6F00",
	"660-paradise-pink": "#E63997",
	"641-red-white-1": "#ED3131",
	"693-fl-pink": "#FF69B4",
	"670-pink": "#E4007C",
	"713-multi-saffron": "#E4B34A",
	"670-pink-smoke": "#D8C5C9",
	"714-saffron": "#D4A017",
	"708-black-coral-blue": "#000000",
	"751-gold-black": "#D4AF37",
	"759-gold-black-navy": "#FFD700",
	"726-yellow-multi": "#E4C861",
	"693-fl-pink-039": "#FF69B4",
	"727-so-lime": "#D0F000",
	"710-gold": "#D4AF37",
	"722-lemon-drop": "#F6E797",
	"689-bright-pink": "#FF007F",
	"719-silver-fl-yellow-black-1": "#C0C0C0",
	"720-yellow": "#FFDA61",
	"731-pac-man": "#FDEE00",
	"754-silver-yellow-blue": "#C0C0C0",
	"711-gold-white": "#E6BE8A",
	"721-marigold": "#EAA221",
	"682-pink-grey": "#D8B8C4",
	"641-coral-reef": "#FF7F50",
	"730-yellow": "#FFDA61",
	"721-sunshine": "#FEDE33",
	"680-polka-dots": "#A9B8BF",
	"756-gold-orange": "#E6B329",
	"747-navy-white-orange": "#000080",
	"716-gold-turquiose-orange": "#D4AF37",
	"734-red-turquoise-blue": "#1fdbf9",
	"731-day-glow-yellow": "#FDF147",
	"723-yellow-orange": "#F2B705",
	"754-yellow-blue": "#F7E118",
	"754-yellow-bue": "#FFEA00",
	"717-silver-red-black": "#C0C0C0",
	"801-orange-pink": "#E97451",
	"705-black-blue-yellow": "#000000",
	"806-silver-orange-black": "#C0C0C0",
	"694-pink-black": "#D87093",
	"758-gold-purple-black": "#A67B5B",
	"717-silver-white-red": "#C0C0C0",
	"778-purple-orange": "#77408F",
	"771-royal-blue-black": "#000000",
	"664-peony": "#E3B7A1",
	"738-black-pink-purple": "#301934",
	"701-amber-ombre": "#A36209",
	"759-gold-navy-black": "#FFD700",
	"804-orange-khaki": "#C19A6B",
	"725-yellow-blue-pink": "#F4E2D6",
	"818-orange-navy": "#FF8000",
	"719-silver-green-yellow": "#BFC293",
	"653-shell": "#F2F1EB",
	"698-clear-orange-blue": "#00A3E0",
	"717-silver-red": "#C0C0C0",
	"730-fl-yellow": "#ecff00",
	"709-blue-orange": "#6495ED",
	"755-gold-royal": "#C09966",
	"779-purple-red": "#A63A79",
	"756-gold-orange-black": "#C09933",
	"754-yellow-orange-blue": "#E8B000",
	"803-pink-orange": "#E6734A",
	"768-black-grey-pink": "#444444",
	"823-blue-coral": "#68A2B9",
	"761-silver-maroon-gold": "#C0C0C0",
	"816-papaya": "#FFEFD5",
	"810-cheetah": "#8F8370",
	"820-fl-orange": "#FF5B00",
	"709-clear-blue-orange": "#FFA500",
	"730-fl-yellow-black": "#FFFF00",
	"718-silver-mint-white": "#E0E5E2",
	"732-citrus": "#FFB300",
	"802-orange-multi": "#ee9045",
	"844-sunset": "#FAD5A5",
	"820-fluorescent-orange": "#FF7900",
	"770-mint-pink": "#98FF98",
	"720-yellow-light-blue-flowers": "#FFFF00",
	"760-gold-pink-black": "#A37447",
	"820-orange": "#FF8000",
	"826-petunia": "#962D6B",
	"810-sun-kiss": "#E9CBA3",
	"816-silver-orange-white": "#C0C0C0",
	"728-yellow-purple": "#CBC3E3",
	"806-silver-f-orange-black": "#C0C0C0",
	"815-orange-white": "#FFA500",
	"829-tiki-coral": "#D07A69",
	"774-grey-gold": "#A2957B",
	"823-pop-coral": "#F25287",
	"776-denim": "#37b4fa",
	"829-coral-sugar": "#FF8C69",
	"822-tangerine": "#FFA726",
	"847-tangelo": "#F08A5D",
	"830-coral-mlt": "#F08080",
	"824-citrine": "#E4D00A",
	"822-cora-lion": "#E07A5F",
	"806-silver-white-orange": "#C0C0C0",
	"775-marine-blue": "#4A646C",
	"823-persimmon-multi": "#F07C49",
	"820-fl-orange-1": "#FF7700",
	"820-coral": "#FF7F50",
	"719-silver-fl-yellow-black": "#C0C0C0",
	"825-persimmon": "#F07663",
	"820-coral-stone": "#A77A6B",
	"838-green-purple-yellow": "#A6A600",
	"841-nectarine": "#FFD580",
	"832-turquoise": "#00C78C",
	"820-bright-coral": "#FF7F50",
	"826-terracotta": "#E2725B",
	"807-silver-burnt-orange-white": "#C0C0C0",
	"808-orange-purple": "#A453A3",
	"841-manic-mango": "#F0A203",
	"750-metallized-gold": "#A89978",
	"824-tangerine": "#F08000",
	"820-fl-orange-black": "#FF7F00",
	"833-lychee": "#F7D6D0",
	"832-coral": "#FF7F50",
	"839-red-sunset": "#EF5350",
	"823-tangelo": "#F08000",
	"766-black-yellow-turquoise": "#00FFFF",
	"810-koi": "#E67E22",
	"905-dark-grey": "#767676",
	"921-usa": "#2E5894",
	"805-white-burnt-orange": "#F5EDE1",
	"886-riviera-rose": "#BE8689",
	"759-gold-navy-navys": "#D4AF37",
	"860-black-blue-green": "#011C2C",
	"845-navy-fuchsia-pink": "#423575",
	"908-green-multi": "#6B8E23",
	"835-peach-yellow": "#ffbe7b",
	"797-pink-red-purple": "#C22568",
	"864-navy-lavender": "#424770",
	"694-pink": "#E37383",
	"828-sunset-coral": "#FD927B",
	"913-navy-green-blue": "#22426B",
	"849-royal-pink": "#843F5B",
	"829-tangerine": "#FFAA70",
	"977-blue-teal": "#008080",
	"892-clear-yellow-blue": "#FFFF00",
	"826-black-burnt-orange": "#332300",
	"861-steel-red": "#B03060",
	"970-assorted": "#696969",
	"967-rainbow-black": "#000000",
	"859-black-blue-pink": "#000000",
	"832-tangerine": "#F28500",
	"917-navy-blue-pink": "#2E3A87",
	"892-clear-yellow": "#F0E68C",
	"810-orange": "#D96003",
	"759-gold-navy": "#FFD700",
	"819-blush": "#DEB887",
	"965-rainbow-pink-orange": "#E9692C",
	"931-rose-gold": "#B76E79",
	"850-blue-grey": "#778899",
	"971-assorted": "#6D6961",
	"94-multi": "#5E2CA5",
	"903-black-olive": "#403A00",
	"898-coral-blue": "#898989",
	"857-navy-yellow-blue": "#002868",
	"843-nectarine": "#FFDAB9",
	"299-gold-mint": "#E0EED6",
	"869-yellow-green": "#9ACD32",
	"968-rainbow-yellow-blue-clear": "#FFFF00",
	"879-turquoise-white": "#E0FFFF",
	"989-black-pink-white": "#000000",
	"983-black-pink-orange": "#000000",
	"869-black-yellow-green": "#000000",
	"979-black-aqua-1": "#008080",
	"781-black-plum": "#211424",
	"855-navy-red-blue": "#191970",
	"960-red": "#990000",
	"669-dragon-fruit": "#A775B0",
	"394-safari-green": "#8BA17B",
	"868-black-purple-blue": "#211E2B",
	"88-green-silver": "#B3BDBA",
	"946-oatmeal-silver": "#EDE6D6",
	"782-plum-pink": "#D269AE",
	"979-black-aqua": "#008080",
	"947-oatmeal-navy": "#F2F1E3",
	"453-wave-blue": "#73C2FB",
	"831-calypso": "#2979CD",
	"984-black-green-blue": "#004098",
	"659-silver-pink": "#CBC0B8",
	"868-yellow-purple-blue": "#A291C6",
	"907-olive-black": "#808000",
	"267-purple-tortoise": "#705898",
	"969-rainbow": "#A295C7",
	"972-bright-blue": "#0096FF",
	"456-blue-black": "#212A36",
	"821-sun-metallic": "#D4A866",
	"519-purple-navy": "#333399",
	"919-navy-purple-pink": "#4B367C",
	"313-green-white": "#FFFFFF",
	"975-deep-teal-heather": "#3097a7",
	"950-charcoal-blue": "#343a40",
	"936-iridescent": "#C1BDBD",
	"943-army-black": "#3f3f3f",
	"651-silver-clear": "#C0C0C0",
	"999-no-color": "#999999",
	"254-light-heather-grey": "#D3D3D3",
	"806-silver-orange-blue": "#A9A9A9",
	"959-silver-multi-black": "#A9A9A9",
	"217-blue-clear": "#ADD8E6",
	"284-brown-black": "#282828",
	"828-sun-coral": "#FFA07A",
	"976-navy-silver": "#000080",
	"372-surf-blue": "#13d1fa",
	"821-mango": "#F0B27A",
	"351-aloha-jade": "#00A36C",
	"794-orange-yellow-pink": "#FFA756",
	"687-pink-mint": "#E6D6C2",
	"180-brown-pink": "#A17A74",
	"971-delphinium-blue-heather": "#59bce9",
	"522-orchid": "#E29CD2",
	"592-steel-pink": "#BC8F8F",
	"715-pale-gold": "#EEE0C2",
	"880-grey-black": "#333333",
	"824-coral": "#FF7F50",
	"262-purple-clear": "#800080",
	"961-black-multi": "#000000",
	"259-brown-tortoise": "#663300",
	"948-oatmeal-blue": "#E3D9C9",
	"631-scarlet": "#9C2921",
	"798-deep-plum": "#704F4F",
	"952-charcoal-silver": "#708090",
	"960-multi": "#432666",
	"505-deep-plum": "#4A3046",
	"973-rainbow-pink-purple": "#DB7093",
	"444-copa-aqua-multi": "#77B5B5",
	"962-cool-multi": "#737CA1",
	"806-silver-orange": "#A7752D",
	"256-heather-white": "#E6E6E6",
	"923-majolica": "#146194",
	"847-navy-blue-yellow": "#002E63",
	"156-smoke-blue-red": "#727272",
	"811-tigerlily": "#E2583E",
	"266-green-clear": "#008000",
	"927-dark-shadow": "#545454",
	"029-slate": "#737CA1",
	"914-eclipse-heather": "#69636B",
	"929-kentucky-blue-heather": "#7F98A6",
	"953-charcoal-black": "#3e474d",
	"459-capri-blue": "#00BFFF",
	"970-multi": "#694A9E",
	"102-stone": "#dddcce",
	"647-carribean-pink": "#E08283",
	"840-zinnia": "#E6B095",
	"901-bronze": "#CD7F32",
	"937-fire": "#B22222",
	"992-north-atlantic": "#4FA395",
	"414-navy-slate": "#1C2841",
	"006-black": "#000000",
	"456-cyan-blue": "#2DD4FF",
	"156-smoke-blue": "#728F80",
	"342-pistachio": "#93C572",
	"926-kentucky-blue": "#a8cff0",
	"264-gold-pink": "#E6BE8A",
	"934-windsor-wine": "#4A0D27",
	"654-pink-navy": "#D4A7C9",
	"458-blazer-blue": "#2E5894",
	"286-camo-black": "#232120",
	"994-heather-grey-black": "#A9A9A9",
	"204-saddle-brown": "#8B4513",
	"464-tide-blue": "#7393B3",
	"401-saphire-beam": "#78A1C7",
	"285-blue-tortoise": "#367C94",
	"360-cyan": "#00FFFF",
	"939-ash-heather": "#e9e9e9",
	"718-silver-mint": "#B9C6C2",
	"811-orange-navy": "#FF8C00",
	"509-clear-purple": "#800080",
	"608-lava-coral": "#B85F56",
	"985-north-atlantic-heather": "#778899",
	"012-pirate-black": "#20201F",
	"616-shell-pink": "#F2B3B3",
	"627-pink-tropics": "#D2929F",
	"507-bittersweet": "#C04337",
	"986-blue-ice": "#95abf2",
	"484-blue-berry": "#778899",
	"635-pink-flash": "#F78AC9",
	"617-ruby": "#9e2f53",
	"809-orange-soda": "#FFA500",
	"384-navy-lime": "#16268C",
	"932-olive-night": "#6B6328",
	"258-smoke-green": "#728F80",
	"406-maritime": "#23395d",
	"633-deep-fuschia": "#A0007A",
	"993-charcoal-heather-black": "#4A4A4F",
	"938-windsor-wine-heather": "#582b36",
	"263-green-mint": "#98FF98",
	"091-black-teal": "#091B1E",
	"930-olive-night-heather": "#545849",
	"918-sky-blue-heather": "#A7D9E9",
	"981-deep-ultramarine-heather": "#545AA7",
	"639-flame-scarlett": "#BE5331",
	"651-pink-cloud": "#DBCDBD",
	"928-majolica-heather": "#64a2ea",
	"644-deep-teal": "#008080",
	"608-cobblestone": "#797568",
	"772-pink-clear": "#F2B7D7",
	"628-azalea": "#F1D1E0",
	"438-moonstone-blue": "#73A9AD",
	"179-silver-grey": "#A7A7A7",
	"220-husk": "#D8C29D",
	"910-purple-rainbow-black": "#000000",
	"612-watermelon": "#E35B71",
	"645-surf-pink": "#C4748F",
	"314-bitter-greens": "#B7B6A4",
	"933-total-eclipse": "#354471",
	"330-lime": "#BEF700",
	"360-pool": "#60BFCF",
	"888-latigo-bay": "#607D8B",
	"409-indigo": "#556B9E",
	"787-silver-purple-navy": "#A29CB7",
	"006-cast-black-1": "#000606",
	"212-chocolate": "#3B2F2F",
	"601-summer-fig": "#B1776E",
	"018-black-blue": "#010816",
	"920-iron-heather": "#5B5A5F",
	"632-melon": "#F0A98F",
	"988-mirage-gray": "#9DA4A7",
	"987-blue-ice-heather": "#A7B4C9",
	"668-peach": "#FFDAB9",
	"990-windchime": "#B4B1A6",
	"493-ocean-navy": "#1E3A8A",
	"995-blue-rainbow-black": "#0A0A0A",
	"114-white-aqua": "#F0FFFF",
	"469-turquoise-tint": "#A7D9ED",
	"225-coco-brown": "#412A1B",
	"613-bloom": "#E9D8A6",
	"405-blue-multi-1": "#3775B0",
	"265-gold-tortoise": "#A98D61",
	"105-clear-blue": "#ADD8E6",
	"630-pink-multi": "#E9967A",
	"241-dark-camel": "#C19A6B",
	"982-black-yellow-purple": "#000000",
	"848-cloisonne": "#3F515B",
	"247-arab-spice": "#D4B396",
	"439-lake": "#509fc4",
	"595-maroon": "#800000",
	"727-marshmallow": "#f9f0cd",
	"455-aruba-blue": "#00A3E0",
	"808-cantalope": "#FFA07A",
	"900-deep-ultramarine": "#0A1172",
	"407-lagoon": "#008080",
	"660-cerise": "#DE3163",
	"844-patriot-blue": "#2E5894",
	"966-medium-grey-heather": "#8E8E8D",
	"988-dusty-turquoise": "#96C5AB",
	"431-royal-blue": "#4169E1",
	"270-sand": "#C2B280",
	"359-marine": "#2A3F54",
	"311-sage": "#A6C694",
	"991-dusky-green": "#495436",
	"039-silver-teal-blue": "#90AFC5",
	"321-emerald": "#136c80",
	"230-smoke-navy": "#50566B",
	"334-lime-navy": "#83e74f",
	"507-raspberry": "#B0486B",
	"824-imperial-blue": "#6050DC",
	"158-clear-red": "#FF0000",
	"814-smoke-orange": "#512800",
	"916-blue-teal-green": "#468499",
	"119-white-mlti": "#F8F8FF",
	"417-clear-navy": "#1D2B53",
	"894-silver-fl-yellow-green": "#B0B0B0",
	"703-citrus": "#F2BE22",
	"072-smoke-white-blue": "#F0F8FF",
	"343-green-navy": "#008081",
	"305-limeade": "#D2E491",
	"714-saffron-1": "#F4B41B",
	"256-white-heather": "#F0EEE3",
	"046-silver-blue-red": "#708090",
	"442-peacoat": "#466B7A",
	"308-green-blue": "#00A36C",
	"319-dark-olive": "#3F3F00",
	"652-magenta": "#C8589B",
	"509-clear-purple-blue": "#A293CA",
	"469-blue-fl-green": "#00A368",
	"351-green-fl-green": "#67FF7D",
	"297-clear-green": "#74B72E",
	"222-bronze-1": "#A87900",
	"163-white-turquoise": "#E0FFFF",
	"490-spring-water": "#EBF2EC",
	"611-red-multi-1": "#B32134",
	"558-smoke-pink": "#E0DCD8",
	"587-voltage": "#2c75ff",
	"528-purple-green": "#7A528B",
	"322-conifer": "#67B168",
	"386-ink": "#294172",
	"824-tangerine-1": "#F08000",
	"661-ultra-pink-1": "#FF69B4",
	"005-black-white-1": "#000000",
	"364-lagoon": "#008B8B",
	"997-rainbow-red": "#E4007C",
	"811-flash-orange": "#FF531A",
	"531-lavender-1": "#E6E6FA",
	"684-rose": "#E6394A",
	"250-grey-white": "#FAFAFA",
	"319-palm-green": "#D0E2A3",
	"470-low-tide": "#A3B18A",
	"802-mango": "#F0B27A",
	"012-black-red": "#000000",
	"714-purple-gold": "#776390",
	"363-seaflower": "#B7C6AB",
	"443-caribbean-aqua": "#00D7FF",
	"430-brt-blue": "#3366FF",
	"973-rainbow-pink": "#E70077",
	"690-persimmon-1": "#F07663",
	"011-blk-blue": "#00008B",
	"330-palm-1": "#D0E2BA",
	"655-silver-multi": "#C0C0C0",
	"294-brt-green": "#80FF00",
	"672-bright-peony": "#D33881",
	"482-riverside": "#708284",
	"692-carousel-pink": "#E6B3B2",
	"454-sea-jewel": "#007A74",
	"492-glacier-blue": "#90B7C6",
	"046-silver-blue": "#C0C0C0",
	"675-radiant-pink": "#E292BC",
	"434-ult-violet": "#444499",
	"344-olive-1": "#808000",
	"472-periwinkle": "#CCCCFF",
	"719-silver-yellow": "#B3B359",
	"624-pop-coral": "#E36B67",
	"448-river-blue": "#79AEC8",
	"298-gold-green": "#A39B56",
	"702-cadmium-yellow": "#FFCD38",
	"532-peri-blue": "#B3BCE2",
	"812-satsuma": "#FF7900",
	"489-riviera-bloom": "#A2A1B4",
	"060-black-ivory": "#000000",
	"317-olive-leaf": "#6B8E23",
	"149-bubble-gum": "#E87A90",
	"758-gold-purple": "#B8860B",
	"625-ruby-red": "#9B111E",
	"787-silver-purple": "#A899A8",
	"731-sunshine": "#FEDB5A",
	"742-black-white-red": "#000000",
	"648-fresh-tomato": "#E34234",
	"668-vivid-snapdragon": "#FF6600",
	"067-black-khaki": "#434034",
	"676-parisian-pink": "#E2B7BD",
	"499-blue-crush-1": "#61A1D5",
	"518-spectrum-blue": "#61799F",
	"005-black-whte": "#000000",
	"927-marine-blue": "#2E5984",
	"433-slate-blue": "#6A5ACD",
	"190-white-sand": "#F5F5DC",
	"249-clay": "#E2D5C4",
	"667-quartz-pnk": "#DBCDBD",
	"102-cream": "#FFFDD0",
	"640-begonia-bloom": "#E6676B",
	"543-white-gum": "#ffffff",
	"323-green-apple": "#A0D6B4",
	"300-clover": "#DBE6D4",
	"687-aloha-pink": "#DA818A",
	"640-begonia-blue": "#66AED2",
	"435-bright-blue": "#66D3FA",
	"002-black-blk": "#000000",
	"104-dune": "#D1C1AC",
	"588-fury": "#ff5000",
	"224-cocoa": "#D2B48C",
	"black-gold": "#000000",
	"623-sea-coral-1": "#FF4040",
	"694-pink-blk": "#D87093",
	"697-aloha-pink": "#D38694",
	"375-jasper": "#D73B32",
	"254-lt-heather-grey": "#D3D3D3",
	"176-cinder": "#929a9a",
	"813-amaryllis": "#A42938",
	"333-lux-teal-1": "#32B7B7",
	"520-lilac": "#B6A2C7",
	"593-raspberry": "#B3446C",
	"301-fern-moss": "#6CB363",
	"235-quartz": "#17a3d8",
	"302-evergreen": "#386B22",
	"911-silver-navy": "#BDBDBD",
	"500-peri": "#7772EC",
	"453-wave-blue-1": "#6F9EBF",
	"571-aqua-pink": "#e45def",
	"474-bright-royal": "#4169E1",
	"666-rose-jam": "#9D486F",
	"589-prismatic": "#A6B1FF",
	"716-mod-citrus": "#D9B06C",
	"733-blue-pink-multi": "#524893",
	"022-black-black": "#000000",
	"008-black-cream": "#000000",
	"684-cupcake": "#e9e9e9",
	"735-red-white-navy": "#B7292E",
	"486-chambry": "#A7C4C9",
	"034-stone-gray-dream-fuschia": "#808080",
	"899-silver-teal": "#83B6B0",
	"837-coral-grey-blue": "#808080",
	"211-java": "#81170c",
	"466-vintage-blue-1": "#7393B3",
	"430-royal-1": "#4169E1",
	"339-elec-lime": "#A7FF00",
	"black-orange": "#000000",
	"blue-green-1": "#005BD3",
	"096-classic-blue-heather": "#4A6487",
	"834-pizazz-pink": "#E772A3",
	"744-neon-yellow": "#D3FF3E",
	"101-clear": "#FFFFFF",
	"625-dorothy": "#af1d1d",
	"blue-green": "#005BD3",
	"377-light-blue-navy": "#ADD8E6",
	"203-pb-j": "#A3735D",
	"126-wht-pink": "#fad5f5",
	"693-bright-wild-berry": "#C35899",
	"473-cerulean-1": "#2A52BE",
	"476-pacific": "#009FE3",
	"321-forest-glen": "#6B8E23",
	"145-grey-lt-blue": "#808080",
	"763-orange-tie-dye": "#E67E22",
	"420-alexis-raptis": "#008eed",
	"475-ultramarine": "#120A8F",
	"013-black-fushia": "#000000",
	"523-frosted-violet": "#9F94B7",
	"480-nautical-blue": "#00308F",
	"440-turquoise-1": "#00BCD4",
	"835-granita": "#A19692",
	"260-beige": "#dadaa9",
	"green-1": "#05AA3D",
	"450-pool-party": "#A5E1E6",
	"263-buff": "#F0DFC4",
	blueberry: "#77B5FE",
	"297-clear-green-green": "#FFFFFF",
	"017-black-orchid": "#0A0026",
	"312-desrt-sage": "#BAB88B",
	"362-lt-blue-aqua": "#38b8ff",
	burgundy: "#800020",
	"697-dark-dusty-rose": "#856463",
	"623-magenta-coral": "#d606ff",
	"164-lunar-met": "#B6BFC5",
	"303-tea": "#CBC0A5",
	"662-sienna": "#A0522D",
	"704-donovan": "#625B53",
	"black-burgundy": "#000000",
	"black-yellow": "#000000",
	"230-smoke-clear-navy": "#727472",
	"698-plumeria": "#F2E8DF",
	"burgundy-gold": "#800020",
	"836-calypso-pink": "#E772A3",
	"633-pink-orange-yellow": "#FFA07A",
	"kelly-green": "#4CBB17",
	"221-cafe": "#221CAF",
	"496-south-pacific": "#00A693",
	"559-clear-turquoise-clear": "#7FFFD4",
	"130-cendre-blue": "#A7B6C2",
	evergreen: "#2D936C",
	"201-cinnabar": "#E34234",
	"027-black-turq-pink": "#000000",
	"181-orange-yellow-yellow": "#FF8A00",
	"489-royal-lime": "#4e63bc",
	"297-clear-black-lime-green": "#000000",
	"153-clear-glitter": "#FFFFFF",
	"101-clear-ice-blue": "#E0FFFF",
	"960-heating-up": "#FF5733",
	"black-green": "#000000",
	"158-clear-red-red": "#FF0000",
	"788-rainbow-navy": "#1E1E4E",
	"719-silver-yellow-yellow": "#C0C0C0",
	"018-black-blue-1": "#00183A",
	"black-blue": "#000000",
	"477-planetary-navy": "#151E3F",
	"grey-pink": "#808080",
	"black-red": "#000000",
	"758-gold-purple-purple": "#A480B9",
	"087-smoke-fl-orange": "#737373",
	gray: "#808080",
	"792-clear-teal-teal": "#008080",
	"394-safari-green-1": "#87A96B",
	"660-rose-light-pink": "#F4B4C3",
	"847-tangelo-1": "#FF9438",
	"169-clear-pink-mint": "#F0F8FF",
	"512-smoke-purple-purple": "#726A95",
	"479-spring-sky": "#87CEEB",
	"308-green-blue-blue": "#008080",
	"355-jade-1": "#00A36C",
	"103-clear-black-black": "#000000",
	"black-white": "#000000",
	"677-rosewater": "#F5E9E2",
	"660-clear-rose": "#FFB6C1",
	"420-blue-blue-blue": "#6666FF",
	"159-clear-grey-grey": "#9F9F9F",
	"424-blue-red-red": "#005BD3",
	"101-clear-clear-clear": "#FFFFFF",
	"417-clear-navy-navy": "#E0E5EC",
	"422-blue-blue-black": "#00008B",
	"152-clear-translucent-pink": "#FFB6C1",
	"756-gold-orange-orange": "#DAA520",
	"968-rainbow-fl-yellow-fl-yellow": "#FFFF00",
	"black-purple": "#000000",
	"586-silver-teal-grey": "#8A958F",
	"438-220-volts-limelight": "#D3E70B",
	"421-royal-light-blue": "#4169E1",
	"973-rainbow-pink-pink": "#E574B4",
	"024-black-glitter-pink-me-up": "#000000",
	"023-black-glitter-limelight": "#000000",
	"494-peacock": "#008080",
	"566-turquoise-grey": "#73A58B",
	"156-smoke-blue-blue": "#727472",
	"black-gray": "#808080",
	"959-smoke-tie-dye-orange": "#595959",
	"968-rainbow-fl-yellow-black": "#FFFF00",
	"691-pink-me-up-yell-oh": "#F2B9B0",
	"073-smoke-black-fl-yellow": "#221F1F",
	"814-goji-berry": "#9D3A3A",
	"085-smoke-fluorescent-green": "#39FF14",
	"105-clear-translucent-blue": "#ADD8E6",
	"421-surf-blue-1": "#7EC8E3",
	"195-coral-grey": "#A8A29E",
	"498-clear-mint-mint": "#B0E2FF",
	"498-clear-grey-mint": "#90EE90",
	"509-clear-purple-lt-purple-1": "#A386C3",
	"103-clear-matte-black-black": "#000000",
	"687-pink-clear-mint": "#E4C3C3",
	"248-grey-pink-lime": "#808080",
	"085-smoke-fl-green-black": "#4B5320",
	"298-gold-green-green": "#A3A14C",
	"398-royal-lt-green": "#96D48F",
	"787-silver-purple-purple": "#787878",
	"846-royal-fushia-coral": "#E35AAE",
	"152-clear-pink-pink": "#F2B7BB",
	"324-nappa-cabbage": "#E0D6C3",
	"751-gold-black-black": "#B8860B",
	"299-gold-mint-grey": "#BDBDBD",
	"568-turq-multi": "#d1df22",
	"673-dark-pink-light-pink": "#E27086",
	"162-smoke-mint-grey": "#E4E8E6",
	"black-glitter-limelight": "#0B0B0B",
	"308-green-green-blue": "#00FF00",
	"559-clear-turq-pink": "#AEE2D0",
	"042-smoke-pink-grey": "#F0F0F0",
	"793-silver-blue-blue": "#A8B3C5",
	"162-smoke-mint-black": "#2B2D2F",
	"194-grey-coral": "#A28B82",
	"074-smoke-black-black": "#36454F",
	"162-smoke-mint": "#E0EBE8",
	"974-rainbow-lt-purple-lt-purple": "#D8BFD8",
	coral: "#FF7F50",
	"035-love-stoned-fade-to-grey": "#ABA7A6",
	clear: "#FFFFFF",
	"390-blue-pink-silver": "#FFFFFF",
	"black-multi": "#000000",
	"049-smoke-teal-teal": "#738276",
	"694-pink-black-pink": "#D87093",
	"718-silver-mint-mint": "#D1E0D1",
	"424-blue-red-blue": "#0000FF",
	assorted: "#FFFFFF",
	"467-turquoise-lime": "#A0D6B4",
	"coral-blue": "#808080",
	"810-clear-orange-orange": "#FFA500",
	"103-clear-smoke-black": "#222222",
	"582-turquoise-grey-white": "#70A1A1",
	"814-smoke-fl-orange-fl-yellow": "#737373",
	"651-silver-clear-clear": "#C0C0C0",
	"465-blue-yellow-yellow": "#0066CC",
	"654-pink-navy-pink": "#DDA0DD",
	"103-clear-red-black": "#000000",
	"755-gold-royal-royal": "#FFD700",
	"192-grey-teal": "#7FB3B0",
	"094-black-fl-yellow-smoke": "#000000",
	"670-pink-pink-pink": "#FFA6C9",
	"651-silver-clear-grey-clear": "#C0C0C0",
	"184-rainbow-pink-f-orange": "#FF69B4",
	"792-clear-tea-teal": "#6FB2A8",
	"487-blue-green-blue": "#0077B5",
	"530-velvet-turquoise": "#166465",
	"420-blue-clear-clear": "#0066FF",
	"804-orange": "#FF8000",
	"103-clear-clear-black": "#000000",
	"759-gold-navy-blue-clear": "#FFD700",
	"697-lime-multi": "#D0F000",
	"105-clear-blue-blue": "#ADD8E6",
	"789-smoke-sage-sage": "#789999",
	"301-olive-ivy": "#6B8E23",
	"547-purple-turquoise-purple": "#703697",
	"grey-red": "#808080",
	"167-blk-mint": "#41d1ca",
	"217-blue-clear-clear": "#3399FF",
	"942-charcoal-mint": "#36454F",
	"949-oatmeal-olive": "#e6e6e6",
	"508-purple-mint-purple-clear": "#800080",
	"361-mint-grey-smoke": "#B7C4B5",
	"757-gold-blue-blue": "#B8860B",
	"191-clear-lt-blue-lt-blue": "#ADD8E6",
	"739-black-white-blue": "#FFFFFF",
	"072-smoke-clear-clear": "#848884",
	"heather-grey": "#A9ABB2",
	"558-smoke-turq-pink": "#708090",
	denim: "#1560BD",
	"558-smoke-pink-pink": "#D8BFD8",
	"090-grey-turquoise": "#73A399",
	"958-slate-multi": "#708090",
	"945-olive-cream": "#C1B579",
	"498-clear-mint-clear": "#98FF98",
	"498-clear-mint-purple": "#90EE90",
	"509-clear-purple-lt-purple": "#E0BBE4",
	"417-clear-navy-grey": "#B0C4DE",
	"510-purple-purple-purple": "#800080",
	"black-turquoise": "#008080",
	"422-blue-black-black": "#00008B",
	"blue-clear": "#ADD8E6",
	"043-silver-black-black": "#C0C0C0",
	"724-pink-pink-yellow": "#F7BCC8",
	"219-grey-mint": "#D1D5D6",
	"085-smoke-fl-green": "#738678",
	"blue-white": "#ADD8E6",
	"247-grey-lime-pink": "#E7E7E7",
	"034-lavender-multi": "#E6E6FA",
	"944-army-cream": "#BCC5A4",
	"686-smoke-grey": "#818589",
	"103-clear-blk": "#000000",
	"maroon-tortoise": "#800000",
	"828-royal-coral": "#DA70D6",
	"257-maroon-tortoise": "#800000",
	"935-orchid-wine": "#B3598F",
	"blue-black": "#000020",
	"400-blue-blue": "#1E88E5",
	"509-clear-purple-grey": "#A29CB0",
	"042-smoke-pink-pink": "#F2DFE4",
	"101-clear-multi": "#FFFFFF",
	"951-charcoal-olive": "#46413A",
	"042-smoke-fl-pink-black": "#121212",
	inferno: "#E25822",
	"251-grey-lt-grey": "#EBEBEB",
	"581-clear-raspberry-green": "#FFFFFF",
	"959-smoke-multi": "#727472",
	"271-tan-grey": "#AFA38D",
	"795-plum-red-deep-plum": "#673A5E",
	"435-teal-org": "#3ba9ca",
	"219-pink-grey-mint": "#D8BDBD",
	"980-teal-aqua": "#008080",
	"692-rose-tortoise": "#BC8F8F",
	"black-white-red": "#FFFFFF",
	"893-clear-coral": "#F08080",
	"722-silver-mint-mint": "#C0C0C0",
	"033-clear-grey-black": "#1A1A1A",
	"796-turquoise-light-blue-navy": "#40E0D0",
	"568-turquoise-multi": "#70D6BB",
	"377-lt-blu-nvy": "#ADD8E6",
	"288-tan-multi": "#D2B48C",
	ink: "#000000",
	"217-blue-clear-rainbow": "#40B4FF",
	"773-denim-denim": "#666A86",
	"gold-black": "#FFD700",
	"508-purple-mint": "#B2B2DF",
	"767-royal-lime-black": "#297ccc",
	"401-navy-2": "#000080",
	"105-clear-blue-grey": "#D0D8E0",
	"766-black-yellow-turquoise-1": "#FFFFFF",
	"909-royal-multi": "#4169E1",
	"025-blue-ice-multi": "#ADD8E6",
	"723-rainbow-f-yellow-f-orange": "#FFC857",
	"fl-yellow": "#FFFF00",
	"484-royal-ylw": "#edec6c",
	"715-smoke-navy-navy": "#727472",
	"498-clear-mint": "#C4DFD0",
	"green-white": "#FFFFFF",
	"895-coral-multi": "#FF7F50",
	"561-smoke-black-turquoise": "#504A4B",
	"967-rainbow-fl-orange-black": "#FF8000",
	"642-clear-red-navy": "#EC4141",
	"dark-grey": "#A9A9A9",
	"785-amber-navy-navy": "#FFBF00",
	"978-teal-multi": "#008080",
	"grey-black": "#434A54",
	"143-white-grape": "#FFFFFF",
	graphite: "#383838",
	"178-smoke-aqua": "#738589",
	"737-black-turquoise-fuschia": "#000000",
	"769-pink-mint-royal": "#E2C4CF",
	"033-grey-blk": "#7c7878",
	multi: "#FFFFFF",
	"062-blk-org": "#000000",
	"343-grn-nvy": "#008080",
	"047-smoke-black-olive": "#364135",
	"078-blk-steel": "#707070",
	"289-off-white": "#FFFFFF",
	"heather-white": "#F5F5F5",
	"961-acid-bath": "#47E5EB",
	"643-pink-teal-grey": "#D8BFD8",
	"957-org-aqu-blk": "#f78c24",
	marine: "#046380",
	"998-wht-brt-pink": "#FFF0F5",
	"111-white-carbon": "#F0F0F0",
	"871-navy-rodode": "#282099",
	"393-indigo": "#4B0082",
	"525-white-red-holiday": "#f73131",
	"897-taupe-multi": "#A79980",
	"809-org-grn": "#f4b003",
	gold: "#D49A06",
	"bubble-gum": "#FFC1CC",
	"239-french-navy": "#282099",
	"961-multi-blk": "#403b36",
	"567-pool-blue": "#43C1EF",
	"791-black-sand": "#ECE1AC",
	"396-midnight": "#2A3484",
	purple: "#800080",
	"030-grey-pink": "#e18e8e",
	"490-blue-turq-turq": "#008080",
	"572-blk-org-yel": "#f4601d",
	"238-navy-light": "#9ba0bd",
	"507-dragonfruit": "#D14D79",
	"328-light-green-black": "#0FD751",
	"004-blk-multi-1": "#000000",
	"393-purple-starlight": "#7824e6",
	"713-grey-red-holiday": "#e13535",
	"306-blk-bone": "#000000",
	"559-clear-turquoise": "#7DF9FF",
	"005-carbon-black": "#000000",
	"957-orange-aqua-black": "#f78c24",
	"108-white-black-1": "#FFFFFF",
	"300-light-green": "#aafd3c",
	"223-plasma": "#CB60F6",
	"652-dark-pink": "#c11c84",
	"145-fresh-grey": "#acacac",
	"014-blk-green": "#147800",
	"585-teal-blue-grey": "#70A1A1",
	"784-red-red-grey": "#A44A44",
	"287-camo-grey": "#223e26",
	multicolor: "#432666",
}
